import * as PIXI from 'pixi.js';

import { TypedSerializableMixin } from '../../serializableMixin';
import { TypedUpdateFlowMixin } from '../../updateFlowMixin';
import {
    AlphaAttribute,
    ColorAttribute,
    NumberAttribute,
    getAttributesToSerialize,
} from '../../attributes';
import { Config } from '../../../video-data/config';

/**
 * Draws a colored bounding box around the entire text(Metrics)
 *
 */
export class CircleGraphic extends TypedUpdateFlowMixin(TypedSerializableMixin(PIXI.Graphics)) {
    override _classType = 'CircleGraphic';
    override _name = Config.CIRCLE_GRAPHIC;

    @NumberAttribute({ min: 0 })
    accessor radius = 0;
    @NumberAttribute({ animatable: false })
    accessor positionX = 0;
    @NumberAttribute({ animatable: false })
    accessor positionY = 0;
    @ColorAttribute()
    accessor strokeColor = 16777215;
    @AlphaAttribute()
    accessor strokeAlpha = 1;
    @NumberAttribute({ min: 0, animatable: false })
    accessor strokeWidth = 0;
    @ColorAttribute()
    accessor fillColor = 16777215;
    @AlphaAttribute()
    accessor fillAlpha = 1;

    override _update() {
        this.clear();
        this.lineStyle(this.strokeWidth, this.strokeColor, this.strokeAlpha);
        this.beginFill(this.fillColor, this.fillAlpha);
        this.drawCircle(this.positionX, this.positionY, this.radius);
        this.endFill();
    }

    override get propertiesToSerialize(): string[] {
        return getAttributesToSerialize(this);
    }
}
